export enum FinancialCategory {
  RENT = 'ALUGUEL',
  WATER_UTILITY = 'ÁGUA',
  ELECTRIC_UTILITY = 'ENERGIA',
  INTERNET_SERVICE = 'INTERNET',
  FUEL = 'COMBUSTÍVEL',
  ALLOWANCE = 'AJUDA DE CUSTO',
  PASTORAL_SUPPORT = 'PREBENDAS',
  MAINTENANCE = 'MANUTENÇÃO',
  CLEANING_SUPPLIES = 'MATERIAIS DE LIMPEZA',
  TAXES = 'IMPOSTOS',
  OTHER = 'OUTROS',
  TITHE = 'DÍZIMO',
  OFERRING = 'OFERTA',
  VOW = 'VOTO'
}

export const EXPENSE_CATEGORIES: FinancialCategory[] = [
  FinancialCategory.RENT,
  FinancialCategory.WATER_UTILITY,
  FinancialCategory.ELECTRIC_UTILITY,
  FinancialCategory.INTERNET_SERVICE,
  FinancialCategory.FUEL,
  FinancialCategory.ALLOWANCE,
  FinancialCategory.PASTORAL_SUPPORT,
  FinancialCategory.MAINTENANCE,
  FinancialCategory.CLEANING_SUPPLIES,
  FinancialCategory.TAXES,
  FinancialCategory.OTHER
];

export const INCOME_CATEGORIES: FinancialCategory[] = [
  FinancialCategory.TITHE,
  FinancialCategory.OFERRING,
  FinancialCategory.VOW,
  FinancialCategory.OTHER
];